import React from "react";
import { GRAPHQL_TO_POINT_MAP_ICON } from "common/constants";
import { pluralize, toSentenceCase } from "common/utils/strings";
import {
  CustomMapGeometryType,
  GetObjectTypesForSettingsQuery,
} from "../../../../generated/graphql";
import ObjectTypePreviewIcon from "../../../Common/ObjectTypePreviewIcon";
import { Body } from "../../../Common/Typography";
import { DropdownMenu } from "../../../Inputs";
import { ActionsProps } from "../../../Inputs/DropdownMenu";
import {
  CardContent,
  CardMainContent,
  CardTextContent,
  CardWrapper,
} from "./__styles__/MapObjects";

type ObjectTypeCustomMap = NonNullable<
  GetObjectTypesForSettingsQuery["account"]
>["customMaps"][number];

const formatGeometryType = (
  geometryType?: Maybe<CustomMapGeometryType>,
): string => {
  if (!geometryType) return "Unknown";
  return toSentenceCase(geometryType);
};

const extractStyleProps = (
  defaultStyles: ObjectTypeCustomMap["defaultStyles"],
) => {
  if (!defaultStyles) {
    return null;
  }

  if (defaultStyles.__typename === "PointDefaultStyles") {
    const { icon, ...rest } = defaultStyles;
    return {
      ...rest,
      iconType: GRAPHQL_TO_POINT_MAP_ICON[icon],
    };
  }

  return { ...defaultStyles };
};

const CustomMapCard = ({
  customMap,
  actions,
}: {
  customMap: ObjectTypeCustomMap;
  actions: Array<ActionsProps>;
}) => {
  const styleProps = extractStyleProps(customMap.defaultStyles);

  return (
    <CardWrapper>
      <CardContent>
        <CardMainContent>
          {styleProps && <ObjectTypePreviewIcon {...styleProps} />}
          <CardTextContent>
            <Body size="large" type="emphasis" color="contentPrimary">
              {customMap.name}
            </Body>
            <Body size="default" type="regular" color="contentSecondary">
              {formatGeometryType(styleProps?.geometryType)} ·{" "}
              {customMap.geometryCount}{" "}
              {pluralize({
                count: customMap.geometryCount,
                options: { singular: "object", plural: "objects" },
              })}
            </Body>
          </CardTextContent>
        </CardMainContent>
        <DropdownMenu actions={actions} />
      </CardContent>
    </CardWrapper>
  );
};

export default CustomMapCard;
